import { addressAutocomplete } from '@loggi/address-geocoder';

let cachedAddresses = [];

function googleMapsAddress(
  value,
  updateSuggestions,
  bounds = null,
  isPlacesEnabled = false,
  sessionToken = null
) {
  if (value) {
    addressAutocomplete(
      value,
      results => {
        cachedAddresses = results.map(data => data);
        updateSuggestions(cachedAddresses);
      },
      bounds,
      isPlacesEnabled,
      sessionToken
    );

    return cachedAddresses;
  }

  cachedAddresses = [];

  return [];
}

export default googleMapsAddress;
